import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css, useTheme } from '../../../styled';
const Logo = ({ logo, logoMobile, logoDarkMode, logoMobileDarkMode, className, wrapper: Wrapper }) => {
    const theme = useTheme();
    function getLogos() {
        if (theme.mode === 'dark') {
            return {
                desktop: logoDarkMode !== null && logoDarkMode !== void 0 ? logoDarkMode : '//eduzz-houston.s3.amazonaws.com/topbar/logos/myeduzz-white.svg',
                mobile: logoMobileDarkMode !== null && logoMobileDarkMode !== void 0 ? logoMobileDarkMode : '//eduzz-houston.s3.amazonaws.com/topbar/logos/myeduzz-mobile.svg'
            };
        }
        return {
            desktop: logo !== null && logo !== void 0 ? logo : '//eduzz-houston.s3.amazonaws.com/topbar/logos/myeduzz.svg',
            mobile: logoMobile !== null && logoMobile !== void 0 ? logoMobile : '//eduzz-houston.s3.amazonaws.com/topbar/logos/myeduzz-mobile.svg'
        };
    }
    const logos = getLogos();
    if (Wrapper) {
        return (_jsxs(Wrapper, Object.assign({ className: className }, { children: [_jsx("img", { className: 'hst-topbar-logo-default', src: logos.desktop }), _jsx("img", { className: 'hst-topbar-logo-mobile', src: logos.mobile })] })));
    }
    return (_jsxs("div", Object.assign({ className: className }, { children: [_jsx("img", { className: 'hst-topbar-logo-default', src: logos.desktop }), _jsx("img", { className: 'hst-topbar-logo-mobile', src: logos.mobile })] })));
};
export default styled(Logo, { label: 'hst-topbar-logo' })(({ theme }) => css `
    height: 80%;
    width: auto;
    margin-inline: 0.5rem;

    & > img {
      max-width: 100%;
      max-height: 100%;
      height: ${theme.components.topBarHeight}px;
    }

    & > .hst-topbar-logo-mobile {
      display: none;
    }

    ${theme.mediaQuery.down('lg')} {
      width: ${theme.pxToRem(32)}rem;

      & .hst-topbar-logo-default {
        display: none;
      }

      & .hst-topbar-logo-mobile {
        display: block;
      }
    }
  `);
